<script>
import WarehouseChangeLogs from './WarehouseChangeLogs'

export default {
  name: 'WarehouseAdjustLogs',
  extends: WarehouseChangeLogs,
  data () {
    return {
      title: this.$t('inventoryChangeLogs'),
      actionName: 'getAdjustLogs',
      headers: [
        { text: '#', align: 'left', sortable: false, width: '5%' },
        { text: this.$t('createTime'), value: 'uid', align: 'left', sortable: false },
        { text: this.$t('from'), value: 'price', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('to'), value: 'quantity', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('operator'), value: '', align: 'left', sortable: false },
        { text: this.$t('siteName'), value: 'createTime', align: 'left', sortable: false },
        { text: this.$t('note'), value: 'note', align: 'left', sortable: false }
      ]
    }
  },
  computed: {
    logs () {
      return this.changeLogs.map(item => {
        item.siteName = item.actionPayload[0].siteName
        item.actionPayload.forEach(ele => {
          ele.organizationId = this.organizationKeyToId.get(ele.organizationKey)
        })
        item.beforeValue.forEach(ele => {
          ele.organizationId = this.organizationKeyToId.get(ele.organizationKey)
        })
        return item
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WarehouseAdjustLogs.vue